import { render, staticRenderFns } from "./PikadayComponent.vue?vue&type=template&id=65432194"
import script from "./PikadayComponent.vue?vue&type=script&lang=js"
export * from "./PikadayComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports